import React from 'react';
import time from 'utils/time';

const RegulationsDocketOverviewTab = ({ currentNew }) => {
  return (
    <>
      {currentNew?.govDocketId && (
        <div className='d-flex align-items-center mb-2'>
          <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Docket ID</span>
          <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
            {currentNew?.govDocketId}
          </span>
        </div>
      )}
      {currentNew?.docketType && (
        <div className='d-flex align-items-center mb-2'>
          <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Docket type</span>
          <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
            {currentNew?.docketType}
          </span>
        </div>
      )}
      {currentNew?.agency && (
        <div className='d-flex align-items-center mb-2'>
          <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Agency</span>
          <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>{currentNew?.agency}</span>
        </div>
      )}
      {currentNew?.effectiveDate && (
        <div className='d-flex align-items-center mb-2'>
          <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Date</span>
          <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
            {time(currentNew?.effectiveDate).formatGeneralDate()}
          </span>
        </div>
      )}
      {currentNew?.sourceUrl && (
        <div className='d-flex align-items-center mb-2'>
          <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Source URL</span>
          <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
            <a
              className='text-light-blue link-hover'
              href={currentNew?.sourceUrl}
              target='_blank'
              rel='noopener noreferrer'
            >
              {currentNew?.sourceUrl}
            </a>
          </span>
        </div>
      )}
    </>
  );
};

export default RegulationsDocketOverviewTab;
